import { AuthHeading, AuthShell, AuthStack, TextButton } from "@majitap/ui";
import { Button } from "@majitap/ui/arc/button/button";
import { useSuspenseQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { meQuery } from "../session";
import { useSignOut } from "../use-sign-out";
import { HELP_LINE } from "./sign-in";

/** The staff assistant, where an investor viewer's access is. */
export const ASSISTANT_URL = import.meta.env?.VITE_ASSISTANT_URL ?? "https://assistant.majitap.com";

/**
 * For staff whose roles open nothing in the console, such as an investor viewer (P15-23): their
 * access is in the assistant, so say so and link there instead of showing an empty console.
 */
export function AssistantAccessPage(): ReactNode {
  const { data: me } = useSuspenseQuery(meQuery);
  const { signOut, pending } = useSignOut();
  return (
    <AuthShell product="Admin console" helpLine={HELP_LINE}>
      <AuthStack>
        <AuthHeading
          title="Your access is in the MajiTap Assistant"
          description={`${me?.active_company?.name ?? "Your company"} gave your role nothing in the admin console. Open the assistant to see what you have access to.`}
        />
        <Button onClick={() => window.location.assign(`${ASSISTANT_URL}/reports/investors`)}>Open the assistant</Button>
        <TextButton onClick={signOut} disabled={pending}>
          Sign out
        </TextButton>
      </AuthStack>
    </AuthShell>
  );
}
